/* eslint-disable */
import React from "react";
import "./src/styles/globalStyle.scss"
import RootElement from "./src/RootElement";

export const wrapRootElement = RootElement;
